import React from 'react';
import { View } from '@adobe/react-spectrum';
import { FilterChip } from '../FilterChip/FilterChip';
import { Divider } from './Divider';
import { SectionLabel } from './SectionLabel';
import { FilterChipGroup } from './useFilterChips';
import styles from './FilterChipsContainer.module.scss';

export interface FilterChipData {
  id: string;
  label: string;
  variant:
    | 'audience'
    | 'productGroup'
    | 'category'
    | 'product'
    | 'event'
    | 'feature'
    | 'lanesTiers'
    | 'genAi'
    | 'revenueImpact'
    | 'status'
    | 'momentType';
  onRemove: () => void;
}

interface FilterChipsContainerProps {
  groups: FilterChipGroup[];
  maxWidth?: string;
}

// Function to get display label for each section type
const getSectionLabel = (type: string): string => {
  switch (type) {
    case 'audience':
      return 'Audience';
    case 'productGroup':
      return 'Prod. Group';
    case 'category':
      return 'Category';
    case 'product':
      return 'Product';
    case 'event':
      return 'Events';
    case 'feature':
      return 'Surface';
    case 'genAi':
      return 'Gen AI';
    case 'revenueImpact':
      return 'Impacts Revenue Targets';
    case 'status':
      return 'Status';
    case 'momentType':
      return 'Moment Type';
    default:
      return type;
  }
};

export function FilterChipsContainer({
  groups,
  maxWidth = '400px'
}: FilterChipsContainerProps) {
  if (groups.length === 0) {
    return null;
  }

  return (
    <View UNSAFE_className={styles.container}>
      {groups.map((group, groupIndex) => (
        <React.Fragment key={group.type}>
          <View UNSAFE_className={styles.sectionGroup}>
            <SectionLabel label={getSectionLabel(group.type)} />
            <View UNSAFE_className={styles.chipsGroup}>
              {group.chips.map(chip => (
                <FilterChip
                  key={chip.id}
                  label={chip.label}
                  variant={chip.variant}
                  onRemove={chip.onRemove}
                />
              ))}
            </View>
          </View>
          {/* Add divider between groups, but not after the last group */}
          {groupIndex < groups.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </View>
  );
}

export type { FilterChipsContainerProps };
